import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuth, useAuthCheck } from '@/hooks/auth';
import { AuthContext, type AuthContextType } from './auth-context';

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const { data } = useAuthCheck();
  const [authInfo, setAuthInfo] = useState<AuthContextType>({
    isAuthenticated: data.isAuthenticated ?? false,
  });

  useEffect(() => {
    setAuthInfo({
      isAuthenticated: data.isAuthenticated ?? false,
    });
  }, [data]);

  return (
    <AuthContext.Provider
      value={{
        ...authInfo,
        setAuthInfo,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

interface ProtectedRouteProps {
  children: ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/signin" state={{ from: { pathname: location.pathname } }} replace />;
  }

  return <>{children}</>;
};
